module.exports = __webpack_public_path__ + "img/menu.0f9e476a.svg";